import { Map } from 'immutable';

import { isObject } from '../../../isObject';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { EMPTY } from '../../../../constants';

export function videos({ channel, operation, preview }) {
  switch (operation) {
    case OPERATIONS[channel].VIDEOS.ADD: {
      return {
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.VIDEOS, ATTRIBUTE.VIDEOS])
            .reduce(
              function reduceValue(result, value) {
                return result.push(
                  isObject(value) && !Map.isMap(value)
                    ? Map(value)
                    : value
                );
              },
              EMPTY.LIST
            ),
        }),
      };
    }

    case OPERATIONS[channel].VIDEOS.DELETE: {
      return {
        payload: Map({
          type: operation,
          value: Map({
            index: preview.getIn([ATTRIBUTE.VIDEOS, ATTRIBUTE.VIDEOS]).keySeq().toList().sort(),
          }),
        }),
      };
    }

    case OPERATIONS[channel].VIDEOS.REPLACE: {
      return {
        payload: preview.getIn([ATTRIBUTE.VIDEOS, ATTRIBUTE.VIDEOS]).reduce(
          function reducePreview(payload, video, index) {
            if (video) {
              payload.push(Map({ type: operation, value: Map({ index, video }) }));
            }

            return payload;
          },
          []
        ),
      };
    }

    default: {
      return {};
    }
  }
}
